import { render } from "./plot-base-panel.vue?vue&type=template&id=62fee0fb&scoped=true"
import script from "./plot-base-panel.vue?vue&type=script&lang=js"
export * from "./plot-base-panel.vue?vue&type=script&lang=js"

import "./plot-base-panel.vue?vue&type=style&index=0&id=62fee0fb&scoped=true&lang=css"

import exportComponent from "C:\\Work\\Projects\\CableLab\\main\\CableLab\\UsbDeviceDriver\\html\\command-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62fee0fb"],['__file',"src/submodules/visualizator-common-components/vue/core/plot-base-panel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62fee0fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62fee0fb', __exports__)) {
    api.reload('62fee0fb', __exports__)
  }
  
  module.hot.accept("./plot-base-panel.vue?vue&type=template&id=62fee0fb&scoped=true", () => {
    api.rerender('62fee0fb', render)
  })

}


export default __exports__